<template>
  <template v-if="pageListChild == 'machineoprate'">
    <!-- 機台稼動率 -->
    <machineOpRate></machineOpRate>
  </template>
  <template v-else-if="pageListChild == 'forgechangetime'">
    <!-- 鍛機換模時間 -->
    <forgeChangeTime></forgeChangeTime>
  </template>
  <template v-else-if="pageListChild == 'forgechangefrequency'">
    <!-- 鍛機換模時間 -->
    <forgeChangeFrequency></forgeChangeFrequency>
  </template>
</template>

<script>
import machineOpRate from "@/components/statisticalReports/opRateStatistics/machineOpRate";
import forgeChangeTime from "@/components/statisticalReports/opRateStatistics/forgeChangeTime";
import forgeChangeFrequency from "@/components/statisticalReports/opRateStatistics/forgeChangeFrequency";
import { inject } from "vue";
export default {
  components: {
    machineOpRate,
    forgeChangeTime,
    forgeChangeFrequency,
  },
  setup() {
    const pageListChild = inject("pageListChild");

    return {
      pageListChild,
    };
  },
};
</script>

<style></style>
